<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <input
                            type="search"
                            placeholder="Search categories"
                            v-model="search"
                            class="form-control"
                        >
                        <span v-if="loading">
                            Loading... <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-if="loaded && categories.length === 0">
                            No categories yet, try adding some.
                        </span>
                    </div>
                    <div class="col-sm-12 col-md-6 text-right">
                        <router-link
                            class="btn btn-info"
                            :to="{name: 'products'}"
                        >
                            View Products
                        </router-link>
                        <button
                            class="btn btn-primary"
                            @click.prevent="addCategory"
                        >
                            <i class="fa fa-plus" />Add Category
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table
                            v-if="loaded && categories.length"
                            class="table categories-table"
                        >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Parent</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(category, index) in filteredCategories"
                                    :key="index"
                                >
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Category name"
                                            class="form-control"
                                            v-model="category.name"
                                            @change="saveCategory(index)"
                                        >
                                    </td>
                                    <td>
                                        <select
                                            v-model="category.parent_id"
                                            class="form-control"
                                            @change="saveCategory(index)"
                                        >
                                            <option
                                                :value="null"
                                            >
                                                No Parent
                                            </option>
                                            <option
                                                v-for="c in categories"
                                                :key="c.id"
                                                :value="c.id"
                                                :disabled="c.id === category.id || c.parent_id === category.id"
                                            >
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="text-right">
                                        <span v-show="category.saving">Saving...</span>
                                        <button
                                            class="btn btn-sm btn-danger"
                                            @click.prevent="deleteCategory(index)"
                                        >
                                            <i class="fa fa-times" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CategoriesService from '../../../services/ProductCategoriesService';
import UsesErrors from '../../../mixins/UsesErrors';
import debounce from 'debounce';

export default {
    mixins: [UsesErrors],

    data () {
        return {
            categories: [],
            loading: false,
            loaded: false,
            search: '',
            saving: false,
        };
    },

    computed: {
        filteredCategories() {
            if (!this.search) {
                return this.categories;
            }

            return this.categories.filter(p => {
                if (p.name.toLowerCase().includes(this.search.toLowerCase())) {
                    return true;
                }
                if (p.code && p.code.toLowerCase().includes(this.search.toLowerCase())) {
                    return true;
                }

                return false;
            });
        },
    },

    mounted () {
        this.loadCategories();
    },
    
    methods: {
        loadCategories () {
            this.loading = true;
            CategoriesService.index().then(res => {
                this.categories = res.data;
                this.loaded = true;
            }).catch(err => {
                this.showErrorMessage('Error: Failed to load categories');
                this.categories = [];
                throw err;
            }).then(() => {
                this.loading = false;
            })
        },

        saveCategory (index) {
            if (this.saving) {
                return;
            }
            let category = this.categories[index];
            if (category.name.trim() === '') {
                return;
            }
            this.saving = true;
            this.categories[index].saving = true;
            CategoriesService.save(category).then(res => {
                this.categories[index] = res.data;
                this.$forceUpdate();
            }).catch(() => {
                this.showErrorMessage('Failed to save category');
            }).then(() => {
                this.saving = false;
                this.categories[index].saving = false;
            });
        },

        deleteCategory (index) {
            let category = this.categories[index];
            let confirm = true;
            if (category.name !== '') {
                confirm = window.confirm('Are you sure you want to delete this category?');
            }
            if (!confirm) {
                return;
            }
            if (!category.id) {
                this.categories.splice(index, 1);
            }
            CategoriesService.delete(category.id).then(() => {
                this.categories.splice(index, 1);
            });
        },

        addCategory () {
            this.search = '';
            return this.categories.push({
                name: '',
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/product-categories/IndexComponent.vue